import { render, staticRenderFns } from "./ApolloVideoGallery.vue?vue&type=template&id=413c5ec3&"
import script from "./ApolloVideoGallery.vue?vue&type=script&lang=js&"
export * from "./ApolloVideoGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports